module.exports = __webpack_public_path__ + "static/media/ic-flag-sg.3f029064.svg";